/*
 * @Author: Kuiper
 * @Date: 2021-06-24 19:33:34
 */
import type { AppRouteRecordRaw, AppRouteModule } from '/@/router/types'

const modules = import.meta.globEager('./modules/**/*.ts')

const routeModuleList: AppRouteModule[] = []

Object.keys(modules).forEach((key) => {
  const mod = modules[key].default || {}
  const modList = Array.isArray(mod) ? [...mod] : [mod]
  routeModuleList.push(...modList)
})

export const asyncRoutes = [...routeModuleList]

export const TestRoute: AppRouteRecordRaw = {
  path: '/test',
  name: 'KuiperTest',
  component: () => import('/@/views/KuiperTest.vue'),
  meta: {
    title: 'KuiperTest',
  },
}

export const RootRoute: AppRouteRecordRaw = {
  path: '/layouts',
  name: 'layouts',
  component: () => import('/@/views/layouts/index.vue'),
  meta: {
    title: 'layouts',
    isMine: true,
  },
  children: [
    {
      path: '/',
      name: 'home',
      component: () => import('/@/views/Index/Personal.vue'),
      meta: {
        title: 'home',
        isMine: true,
      },
    },
    {
      path: '/introduce',
      name: 'introduce',
      component: () => import('/@/views/Index/introduce.vue'),
      meta: {
        title: 'introduce',
        requireAuth: false,
        isMine: true,
      },
    },
    {
      path: '/disk',
      name: 'disk',
      component: () => import('/@/views/material/PersonPage.vue'),
      meta: {
        title: 'disk',
        requireAuth: true,
        isMine: true,
      },
    },
    {
      path: '/pcshare',
      name: 'pcshare',
      component: () => import('/@/views/iframe/FrameBlank.vue'),
      meta: {
        title: 'pcshare',
        isMine: true,
      },
    },
  ],
}
export const downLoadRoute: AppRouteRecordRaw = {
  path: '/download',
  name: 'Download',
  component: () => import('/@/views/downloadPage/downloadPage.vue'),
  meta: {
    title: 'Download',
  },
}
// Basic routing without permission
export const basicRoutes = [RootRoute, TestRoute, downLoadRoute]
